import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ChumonCSVForIwamura} from '../../interfaces/chumon';
import {FirestoreMasterService} from '../../../core/service/firestore-master.service';
import {CommonService} from '../../../core/service/common.service';
import {MasterService} from '../../../core/service/master.service';
import {Keishu} from '../../interfaces/keishu';
import {ChumonService} from '../../../core/service/chumon.service';
import {Observable} from 'rxjs';
import {AngularFirestore} from '@angular/fire/firestore';
import {COLLECTION_NAME} from '../../constants';
import {MessageService} from '../../../core/service/message.service';

@Component({
  selector: 'app-add-keishu-dialog',
  templateUrl: './add-keishu-dialog.component.html',
  styleUrls: ['./add-keishu-dialog.component.scss']
})
export class AddKeishuDialogComponent {
  willAdd = true;
  newKeishu: Keishu;
  selectedSpecies: any = null;
  selectedKeishu: Keishu | null = null;
  speciesObservable = new Observable<Keishu[]>();
  constructor(@Inject(MAT_DIALOG_DATA) public data: ChumonCSVForIwamura,
              private db: AngularFirestore,
              private firestoreService: FirestoreMasterService,
              private messageService: MessageService,
              public commonService: CommonService,
              public masterService: MasterService,
              public chumonService: ChumonService,
              public matDialogRef: MatDialogRef<AddKeishuDialogComponent>,) {
    this.speciesObservable = this.db.collection('globalMasters')
      .doc('ALL').collection('species').valueChanges({idField: 'id'}) as Observable<Keishu[]>;
    this.newKeishu = {
      id: '',
      name: '',
      keishuRyakushou: data.keishu,
      shiyuu: chumonService.getShiyuu(data.osuMesu),
      mokuhyouTemperatureId: '',
      weights: {},
      isDeleted: false
    };
    console.log('AddKeishuDialogComponent opened');
  }

  /**
   *
   */
  register() {
    this.newKeishu.id = this.selectedSpecies.id;
    this.newKeishu.name = this.selectedSpecies.name;
    this.newKeishu.weights = {...this.selectedSpecies.weights};
    if (this.isExist()) {
      this.messageService.pushError('同じ鶏種が登録されています');
      return;
    }
    this.firestoreService.saveMasterDoc(COLLECTION_NAME.KEISHUMASTER, this.newKeishu, this.newKeishu.id)
      .then(() => {
        // 新規追加した明細もマスタの更新をトリガーとしてマスタサービスで保持している出荷先マスタに追加されるはずだが、
        // 利用するタイミングまでに更新が間に合わない可能性があるので、ここで追加してしまう。
        this.masterService.keishuMaster.push(this.newKeishu);
        this.messageService.pushInfo('追加しました');
        console.log('document successfully registered!');
        this.commonService.onClick(this.matDialogRef, '1');
      }).catch(error => {
        this.messageService.pushError('追加に失敗しました');
        console.log(error);
      });
  }

  /**
   * 新規作成しようとしている鶏種が登録済みかチェック
   * @private
   */
  private isExist() {
    return this.masterService.keishuMaster.find(item => {
      return item.id === this.newKeishu.id && !item.isDeleted;
    });
  }

  /**
   * 既存の鶏種から選択
   * 選択した値をcsvRowにセット
   */
  selectExistingValue() {
    if (this.selectedKeishu) {
      this.data.keishuId = this.selectedKeishu.id;
      this.data.keishu = this.selectedKeishu.keishuRyakushou.replace('♂', '');
    }
    this.commonService.onClick(this.matDialogRef);
  }
}
